/* eslint-disable react-hooks/exhaustive-deps */
import Header from "./Header/Header";
import Loader from "./Loader/Loader";
import TapTop from "./TapTop/TapTop";
import { useAppDispatch, useAppSelector } from "../ReduxToolkit/Hooks";
import { Outlet } from "react-router-dom";
import Footer from "./Footer/Footer";
import { setSidebarClose } from "../ReduxToolkit/Reducers/LayoutSlice";
import { useEffect } from "react";
import { setLayout } from "../ReduxToolkit/Reducers/ThemeCustomizerSlice";
import Sidebar from "./Sidebar/Sidebar";
import ThemeCustomizer from "./ThemeCustomizer/ThemeCustomizer";

const Layout = () => {
  const {layout} = useAppSelector((state)=>state.themeCustomizer)
  const dispatch = useAppDispatch();
  const { sidebarClose } = useAppSelector((state) => state.layout);
  const compactSidebar = () => {
    let windowWidth = window.innerWidth;
    if (layout === "compact-wrapper modern-type") {
      if (windowWidth < 1200) {
        dispatch(setSidebarClose(true));
      } else {
        dispatch(setSidebarClose(false));
      }
    }
    else if(layout === "horizontal-wrapper"){
      if (windowWidth < 1200) {
        dispatch(setSidebarClose(true))
        dispatch(setLayout("compact-wrapper modern-type"))
      } 
      else {
        dispatch(setSidebarClose(false))
        dispatch(setLayout(localStorage.getItem("layout")))
      }
    }
  };
   
  useEffect(() => {
    compactSidebar();
    window.addEventListener("resize", () => {
      compactSidebar();
    });
  }, [layout]);
  return (
    <>
      <div className={`page-wrapper ${layout} ${sidebarClose ? "sidebar-close" : "" }` } id="pageWrapper">
        <Header />
        <div className="page-body-wrapper" >
          <Sidebar />
          <Outlet />
          <Footer />
        </div>
      </div>
      <ThemeCustomizer />
      <Loader />
      <TapTop />
    </>
  );
};

export default Layout;
